export const DEFAULT_STORE_TIME_ZONE = "Europe/London";
